import { react, useEffect, useState, useRef } from 'react';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Fab from '@mui/material/Fab';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import GoogleMapsAutocomplete from '../GoogleMapsAutocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import TokenService from '../../services/TokenService';
import MapAreaSelector_Michigan from './MapAreaSelector_Michigan'
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useSnackbar } from 'notistack';

const usStates = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
];


export default function FundraiserSignup(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [donationId, setDonationId] = useState(0);
    const [donationTitle, setDonationTitle] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companyEmail, setCompanyEmail] = useState('');
    const [companyEmail2, setCompanyEmail2] = useState('');
    const [payeeName, setPayeeName] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('DIGITAL CHECK');
    //MAILED CHECK, DIGITAL CHECK
    const [aCH_RoutingNumber, setACH_RoutingNumber] = useState('');
    const [aCH_AccountNumber, setACH_AccountNumber] = useState('');
    const [aCH_AccountType, setACH_AccountType] = useState('Checking');
    const [memo, setMemo] = useState('');
    const [companyAddress, setCompanyAddress] = useState('');
    const [companyAddress2, setCompanyAddress2] = useState('');
    const [companyCity, setCompanyCity] = useState('');
    const [companyState, setCompanyState] = useState('');
    const [companyZipcode, setCompanyZipcode] = useState('');
    const [companyType, setCompanyType] = useState('Fundraiser');
    const [companyDescription, setCompanyDescription] = useState('');
    const [website, setWebsite] = useState('');
    //const [startDate, setStartDate] = useState('');
    //const [endDate, setEndDate] = useState('');
    const [centroid, setCentroid] = useState({ lat: 42.7335414, lng: -84.5555663 });
    const { enqueueSnackbar } = useSnackbar();
    const [state, setState] = useState('');
    const [zipcodes, setZipcodes] = useState([]);

    const imageInputRef = useRef(null);
    const [images, setImages] = useState([]);

    const [donationSummary, setDonationSummary] = useState(null);



    function handleUploadImageClick(event) {
        let file = event.target.files[0];
        const reader = new FileReader();
        var url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {


            // resize the imagage
            var img = document.createElement("img");
            img.onload = function (event) {
                var MAX_WIDTH = 1024;
                var MAX_HEIGHT = 1024;

                var width = img.width;
                var height = img.height;

                // Change the resizing logic
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                // Actual resizing
                ctx.drawImage(img, 0, 0, width, height);



                // Show resized image in preview element
                var dataurl = canvas.toDataURL(file.type);
                //document.getElementById("preview").src = dataurl;

                //let imagesCopy = images.slice();
                //imagesCopy.push({
                //    imageId: uuidv4(),
                //    imageData: dataurl
                //});
                setImages([{
                    imageId: uuidv4(),
                    imageData: dataurl
                }]);
            }
            img.src = reader.result;


        }.bind(this);
        // Reset the value of the input so the same file can be uploaded again
        event.target.value = null;
    };

    function isValidUrl(string) {
        const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

        return !!pattern.test(string);
    }

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    function isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    }

    function getImages() {
        if (images !== null && images.length > 0) {

            return (
                <div style={{display:'flex'} }>
                    <img src={images[0].imageData} style={{ width:'80%', maxWidth: '330px' }} />
                    <Fab style={{ left: '-25px' }} onClick={() => setImages([]) }><CloseIcon /></Fab>
                </div>
            );
        }
        else {
            return null;
        }

    }

    function isValidRoutingNumber(routingNumber) {
        if (!/^\d{9}$/.test(routingNumber)) {
            // Fails the basic regex test for being exactly 9 digits
            return false;
        }

        const weights = [3, 7, 1, 3, 7, 1, 3, 7, 1];
        let sum = 0;

        for (let i = 0; i < 9; i++) {
            sum += parseInt(routingNumber.charAt(i), 10) * weights[i];
        }

        return sum % 10 === 0;
    }

    function validateAndSubmit() {
        let isValid = true;
        let errors = {};
       
        if (donationTitle.trim() == '') {
            errors['donationTitle'] = 'Required';
            isValid = false;
        }

        if (companyName.trim() == '') {
            errors['companyName'] = 'Required';
            isValid = false;
        }

        if (companyDescription.trim() == '') {
            errors['companyDescription'] = 'Required';
            isValid = false;
        }

        if (website.trim() != '') {
            if (!isValidUrl(website)) {
                errors['website'] = 'Not a valid URL';
                isValid = false;
            }
           
        }

        if (companyEmail.trim() == '') {
            errors['companyEmail'] = 'Required';
            isValid = false;
        }
        else {
            if (companyEmail2.trim() == '') {
                errors['companyEmail2'] = 'Required';
                isValid = false;
            }
            else {
                if (companyEmail.trim().toLowerCase() != companyEmail2.trim().toLowerCase()) {
                    errors['companyEmail2'] = 'Emails do not match';
                    isValid = false;
                }
                else {
                    if (!isValidEmail(companyEmail.trim())) {
                        isValid = false;
                        errors["companyEmail"] = "Not a valid Email.";

                    }
                    else {
                        if (companyEmail.trim().toLowerCase().indexOf('@gmail.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@gmail.com') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @gmail.com?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@yahoo.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@yahoo.com') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @yahoo.com?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@hotmail.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@hotmail.com') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @hotmail.com?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@aol.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@aol.com') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @aol.com?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@comcast.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@comcast.net') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @comcast.net?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@sbcglobal.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@sbcglobal.net') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @sbcglobal.net?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@icloud.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@icloud.com') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @icloud.com?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@outlook.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@outlook.com') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @outlook.com?";
                        }
                        else if (companyEmail.trim().toLowerCase().indexOf('@msn.') > -1 &&
                            companyEmail.trim().toLowerCase().indexOf('@msn.com') == -1) {
                            isValid = false;
                            errors["companyEmail"] = "Did you mean @msn.com?";
                        }

                    }
                }
            }
        }

        //if (typeof startDate === 'string') {
        //    if (startDate == '') {
        //        errors['startDate'] = 'Required';
        //        isValid = false;
        //    }
        //}

        //if (typeof endDate === 'string') {
        //    if (endDate == '') {
        //        errors['endDate'] = 'Required';
        //        isValid = false;
        //    }
        //}

        //if (typeof startDate === 'object' && typeof endDate === 'object') {
        //    if (startDate.isAfter(endDate)) {
        //        errors['endDate'] = 'Must be after the Start';
        //        isValid = false;
        //    }
        //    else if (endDate.diff(startDate, 'month', true) > 3) {
        //        errors['endDate'] = 'Max is 3 months';
        //        isValid = false;
        //    }
        //}

        if (payeeName.trim() == '') {
            errors['payeeName'] = 'Required';
            isValid = false;
        }

        if (paymentMethod == 'MAILED CHECK') {
            if (companyAddress.trim() == '') {
                errors['companyAddress'] = 'Required';
                isValid = false;
            }

            if (companyCity.trim() == '') {
                errors['companyCity'] = 'Required';
                isValid = false;
            }

            if (companyState.trim() == '') {
                errors['companyState'] = 'Required';
                isValid = false;
            }

            if (companyZipcode.trim() == '') {
                errors['companyZipcode'] = 'Required';
                isValid = false;
            }
        }
        else if (paymentMethod === 'ACH') {
            if (aCH_RoutingNumber == '') {
                errors['aCH_RoutingNumber'] = 'Please provide your bank\'s ABA Routing Number';
                isValid = false;
            }
            else if (!isValidRoutingNumber(aCH_RoutingNumber)) {
                errors['aCH_RoutingNumber'] = 'Not a valid routing number.';
                isValid = false;
            }
            if (aCH_AccountNumber == '') {
                errors['aCH_AccountNumber '] = 'Missing your Account Number';
                isValid = false;
            }
        }

        setFormErrors(errors);

        if (isValid) {
            let postData = {
                donationConfiguration: {
                    donationTitle: donationTitle,
                    companyName: companyName,
                    companyEmail: companyEmail,
                    companyDescription: companyDescription,
                    payeeName: payeeName,
                    paymentMethod: paymentMethod,
                    memo: memo,
                    companyAddress: paymentMethod == 'DIGITAL CHECK' ? '' : companyAddress,
                    companyAddress2: paymentMethod == 'DIGITAL CHECK' ? '' : companyAddress2,
                    companyCity: paymentMethod == 'DIGITAL CHECK' ? '' : companyCity,
                    companyState: paymentMethod == 'DIGITAL CHECK' ? '' : companyState,
                    companyZipcode: paymentMethod == 'DIGITAL CHECK' ? '' : companyZipcode,
                    aCH_RoutingNumber: paymentMethod === 'ACH' ? aCH_RoutingNumber : '',
                    aCH_AccountNumber: paymentMethod === 'ACH' ? aCH_AccountNumber : '',
                    aCH_AccountType: paymentMethod === 'ACH' ? aCH_AccountType : '',
                    companyType: companyType,
                    website: website,
                    //startDate: startDate.format('MM-DD-YYYY'),
                    //endDate: endDate.format('MM-DD-YYYY'),
                    zipcodes: []
                },
                images: images,
                centroid: centroid
            }

            //if (images !== null && images.length > 0) {
            //    postData.image = images[0].imageData;
            //}

            postData = {
                donationBody: JSON.stringify(postData)
            }

            setIsLoading(true);
            TokenService.customerPost(postData, 'DonationSignup', '')
                .then((response) => {
                    setIsLoading(false);
                    if (response.Result === undefined) {
                        let keys = Object.keys(response);
                        response = response[keys[0]];
                    }
                    if (response.Result === 'SUCCESS') {
                        setDonationSummary(JSON.parse(response.JsonData));
                    }
                    else {
                        if (response.Message !== undefined) {
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                        else if (response.Error !== undefined) {
                            enqueueSnackbar(response.Error, {
                                variant: 'error',
                            });
                        }
                        else {
                            enqueueSnackbar('Oops, something went wrong', {
                                variant: 'error',
                            });
                        }
                    }

                })
                .catch((response) => {
                    //error occurred? Don't stop the customer's order
                    setIsLoading(false);
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });

        }
        else {
            enqueueSnackbar('There are some errors that need to be fixed.', {
                variant: 'warning',
            });
        }
    }

    function setAddressFromGoogleData(googleData) {
        if (googleData !== null) {
            // last 3 items in googleData.terms are Country, State, City. Put everything else as the Street
            let streetAddress = '';
            if (googleData !== null) {
                if (googleData.terms.length > 3) {
                    for (let i = 0; i < googleData.terms.length - 3; i++) {
                        streetAddress += googleData.terms[i].value + " ";
                    }
                    streetAddress = streetAddress.trim();
                    setCompanyAddress(streetAddress);
                    setCompanyCity(googleData.terms[googleData.terms.length - 3].value);
                    setCompanyState(googleData.terms[googleData.terms.length - 2].value);
                    if (googleData.postalCode) {
                        setCompanyZipcode(googleData.postalCode);
                    }
                   // setCompanyZipcode(props.pickupData.ZipCodeInfo.Zipcode);
                }
                else {
                    setCompanyCity('');
                    setCompanyState('');
                }
            }

        }
    }

    function buildLoadingPanel() {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="50px"
            >
                <CircularProgress color="secondary" />
            </Box>
        )

    }

    return (
        <div style={{ padding: '5px' }}>
            {isLoading ? buildLoadingPanel()
                :
                donationSummary !== null ?
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                            Thank you for joining us in our mission to support sustainability and charitable giving through recycling!
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                            We have sent you an email to {companyEmail}. To complete the verification process, please click the link in the email to finish setting up your account.
                        </div>
                    </>
                :
                <>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontSize: '14pt', fontWeight: 'bold' }}>
                            Fundraiser Signup
                        </div>
                        <Button onClick={() => props.OnBack()}>Cancel <CloseIcon /></Button>
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <TextField label='Fundraiser Title' value={donationTitle} onChange={(e) => setDonationTitle(e.target.value)} error={formErrors['donationTitle'] !== undefined} />
                        {formErrors['donationTitle'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['donationTitle']}</div>
                        }
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <div>
                            Who/What is the fundraiser is for
                        </div>
                        <TextField label='Name' value={companyName} onChange={(e) => setCompanyName(e.target.value)} error={formErrors['companyName'] !== undefined} />
                        {formErrors['companyName'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyName']}</div>
                        }
                    </div>



                    <div style={{ marginTop: '15px' }}>
                        <div>
                            Short description of your fundraiser
                        </div>
                        <TextField label='Description' value={companyDescription} onChange={(e) => setCompanyDescription(e.target.value)} error={formErrors['companyDescription'] !== undefined} />
                        {formErrors['companyDescription'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyDescription']}</div>
                        }
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <div>
                            Do you have website or link to a page?
                        </div>
                        <TextField label='Website (optional)' value={website} onChange={(e) => setWebsite(e.target.value)} error={formErrors['website'] !== undefined} />
                        {formErrors['website'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['website']}</div>
                        }
                    </div>

                    

                    <>

                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', marginTop: '10px' }}>
                            <Button variant='outlined' onClick={() => imageInputRef.current.click()} style={{ marginLeft:'auto',marginRight:'auto', color: formErrors['image'] !== undefined ? '#cc0000' : 'black', borderColor: formErrors['image'] !== undefined ? '#cc0000' : 'black', maxWidth:'300px' }}>
                                Would you like to add a Photo or Image?
                                <AddAPhotoIcon sx={{ color: formErrors['image'] !== undefined ? '#cc0000' : 'black' }} />
                            </Button>
                            <input
                                ref={imageInputRef}
                                style={{ display: 'none' }}
                                accept="image/*"
                                id="contained-button-file"
                                multiple
                                type="file"
                                onChange={handleUploadImageClick}
                            />
                        </div>


                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                            {getImages()}
                        </div>
                    </>

                    <div style={{ marginTop: '15px', borderTop: '3px solid var(--sipzee-gray-2)' }}>
                        The below items are not visible to customers:
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <TextField label='Email' value={companyEmail} onChange={(e) => setCompanyEmail(e.target.value)} error={formErrors['companyEmail'] !== undefined} />
                        {formErrors['companyEmail'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyEmail']}</div>
                        }
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <TextField label='Re-enter your Email' value={companyEmail2} onChange={(e) => setCompanyEmail2(e.target.value)} error={formErrors['companyEmail2'] !== undefined} />
                        {formErrors['companyEmail2'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyEmail2']}</div>
                        }
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <TextField label='Checks made out to' value={payeeName} onChange={(e) => setPayeeName(e.target.value)} error={formErrors['payeeName'] !== undefined} />
                        {formErrors['payeeName'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['payeeName']}</div>
                        }
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <TextField label='Check Memo (optional)' value={memo} onChange={(e) => setMemo(e.target.value)} error={formErrors['memo'] !== undefined} />
                        {formErrors['memo'] == undefined ? null :
                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['memo']}</div>
                        }
                    </div>

                    <div style={{ marginTop: '15px' }}>
                        <Button variant='outlined' style={{ backgroundColor: paymentMethod == 'DIGITAL CHECK' ? 'var(--sipzee-green)' : null }} onClick={() => setPaymentMethod('DIGITAL CHECK')}>Digital Check</Button>
                            <Button variant='outlined' style={{ backgroundColor: paymentMethod == 'MAILED CHECK' ? 'var(--sipzee-green)' : null }} onClick={() => setPaymentMethod('MAILED CHECK')}>Mailed Check</Button>
                            <Button variant='outlined' style={{ backgroundColor: paymentMethod == 'ACH' ? 'var(--sipzee-green)' : null }} onClick={() => setPaymentMethod('ACH')}>ACH</Button>
                    </div>

                        {paymentMethod == 'DIGITAL CHECK' ?
                            <div style={{ fontWeight: 'bold', marginTop: '5px', marginBottom: '10px' }}>
                                Digital checks will be emailed to you. They can be printed and brought to your bank or mobile deposited using your banking app.
                            </div>
                            : paymentMethod == 'ACH' ?
                                <>
                                    <div style={{ marginTop: '15px' }}>
                                        <TextField label='Routing Number'
                                            inputProps={{
                                                maxLength: 9
                                            }}
                                            value={aCH_RoutingNumber} onChange={(e) => setACH_RoutingNumber(e.target.value)} error={formErrors['aCH_RoutingNumber'] !== undefined} />
                                        {formErrors['aCH_RoutingNumber'] == undefined ? null :
                                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['aCH_RoutingNumber']}</div>
                                        }
                                    </div>

                                    <div style={{ marginTop: '15px' }}>
                                        <TextField label='Account Number' value={aCH_AccountNumber} onChange={(e) => setACH_AccountNumber(e.target.value)} error={formErrors['aCH_AccountNumber'] !== undefined} />
                                        {formErrors['aCH_AccountNumber'] == undefined ? null :
                                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['aCH_AccountNumber']}</div>
                                        }
                                    </div>

                                    <div style={{ marginTop: '15px' }}>
                                        <FormControl>
                                            <FormLabel id="demo-radio-buttons-group-label">Account Type</FormLabel>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                value={aCH_AccountType}
                                                onChange={(e) => {
                                                    setACH_AccountType(e.target.value)
                                                }}
                                                name="radio-buttons-group"
                                            >
                                                <FormControlLabel value="Checking" control={<Radio />} label="Checking" />
                                                <FormControlLabel value="Savings" control={<Radio />} label="Savings" />

                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </>
                                :
                                <>
                                    <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                        <div style={{ alignSelf: 'center' }}>
                                            <GoogleMapsAutocomplete error={formErrors['companyAddress'] !== undefined} label="Start typing your address..." RequestZipcode={true} onSelected={(googleData) => setAddressFromGoogleData(googleData)} value={companyAddress} variant="outlined" />
                                        </div>
                                        {formErrors['companyAddress'] == undefined ? null :
                                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt', alignSelf: 'center' }}>{formErrors['companyAddress']}</div>
                                        }
                                    </div>
                                    <div style={{ marginTop: '15px' }}>
                                        <TextField label='Apt/Suite/Other' value={companyAddress2} onChange={(e) => setCompanyAddress2(e.target.value)} error={formErrors['companyAddress2'] !== undefined} />
                                        {formErrors['companyAddress2'] == undefined ? null :
                                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyAddress2']}</div>
                                        }
                                    </div>
                                    <div style={{ marginTop: '15px' }}>
                                        <TextField label='City' value={companyCity} onChange={(e) => setCompanyCity(e.target.value)} error={formErrors['companyCity'] !== undefined} />
                                        {formErrors['companyCity'] == undefined ? null :
                                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyCity']}</div>
                                        }
                                    </div>
                                    <div style={{ marginTop: '15px' }}>
                                        <TextField
                                            style={{ minWidth: '223px' }}
                                            value={companyState}
                                            onChange={(e) => setCompanyState(e.target.value)}
                                            error={formErrors['companyState'] !== undefined}
                                            id="outlined-select-currency"
                                            select
                                            label="State"
                                            defaultValue="MI"
                                        >
                                            {usStates.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {formErrors['companyState'] == undefined ? null :
                                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyState']}</div>
                                        }
                                    </div>
                                    <div style={{ marginTop: '15px' }}>
                                        <TextField type='number' label='Zip' value={companyZipcode} onChange={(e) => setCompanyZipcode(e.target.value)} error={formErrors['companyZipcode'] !== undefined} maxLength={15} />
                                        {formErrors['companyZipcode'] == undefined ? null :
                                            <div style={{ color: 'var(--sipzee-red)', fontSize: '10pt' }}>{formErrors['companyZipcode']}</div>
                                        }
                                    </div>
                                </>
                        }

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                        Anyone in Michigan will be able to find your fundraiser.
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', fontStyle:'italic' }}>
                        Select the area that is most local to your fundraiser.
                    </div>
                   

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <MapAreaSelector_Michigan onChange={(selected) => setCentroid(selected)} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                        <FormGroup>
                            <FormControlLabel control={<StyledCheckbox checked={agreeToTerms} onChange={(e) => setAgreeToTerms(e.target.checked)} />} label={<span>I agree to the <a target='_blank' href='https://sipzee.com/donate_org_terms.aspx'>Terms of Use</a></span>} />
                        </FormGroup>
                    </div>


                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                        <div style={{ display: 'flex', width: '300px', justifyContent: 'center' }}>
                            <Button variant={agreeToTerms ? 'contained' : 'outlined'} disabled={!agreeToTerms} color="sipzeeGreen" onClick={() => validateAndSubmit()}>Submit</Button>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}